import React, { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase/config";
import { Link } from "react-router-dom";
import { FiShoppingBag, FiBookOpen, FiCalendar, FiTag } from "react-icons/fi";

const Dashboard = () => {
  const [stats, setStats] = useState({ products: 0, blogs: 0, events: 0, categories: 0 });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [prod, blog, evt, cat] = await Promise.all([
          getDocs(collection(db, "products")),
          getDocs(collection(db, "blogs")),
          getDocs(collection(db, "events")),
          getDocs(collection(db, "productCategories")),
        ]);
        setStats({
          products: prod.size,
          blogs: blog.size,
          events: evt.size,
          categories: cat.size,
        });
      } catch (e) {}
    };
    fetchStats();
  }, []);

  const cards = [
    { label: "Total Products", value: stats.products, icon: <FiShoppingBag size={24} />, color: "bg-pink-50 text-[#e84fa5]", link: "/admin/products" },
    { label: "Blog Posts", value: stats.blogs, icon: <FiBookOpen size={24} />, color: "bg-purple-50 text-purple-500", link: "/admin/blogs" },
    { label: "Events", value: stats.events, icon: <FiCalendar size={24} />, color: "bg-blue-50 text-blue-500", link: "/admin/events" },
    { label: "Categories", value: stats.categories, icon: <FiTag size={24} />, color: "bg-green-50 text-green-500", link: "/admin/product-categories" },
  ];

  const quickLinks = [
    { label: "Add Product", to: "/admin/products/new", color: "bg-[#e84fa5] text-white" },
    { label: "Add Blog Post", to: "/admin/blogs/new", color: "bg-purple-500 text-white" },
    { label: "Add Event", to: "/admin/events/new", color: "bg-blue-500 text-white" },
    { label: "Site Settings", to: "/admin/settings", color: "bg-gray-800 text-white" },
  ];

  return (
    <AdminLayout>
      <div>
        <div className="mb-8">
          <h1 className="text-2xl font-extrabold text-black">Dashboard</h1>
          <p className="text-sm text-gray-400 mt-1">Welcome back! Here's an overview.</p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
          {cards.map((card) => (
            <Link key={card.label} to={card.link} className="bg-white rounded-xl border border-gray-100 p-6 hover:shadow-md transition">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${card.color}`}>
                {card.icon}
              </div>
              <div className="text-3xl font-extrabold text-black">{card.value}</div>
              <div className="text-[12px] text-gray-500 mt-1">{card.label}</div>
            </Link>
          ))}
        </div>

        {/* Quick Actions */}
        <div className="bg-white rounded-xl border border-gray-100 p-6">
          <h2 className="text-[14px] font-bold mb-5">Quick Actions</h2>
          <div className="flex flex-wrap gap-3">
            {quickLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className={`px-5 py-2.5 rounded-lg text-[13px] font-bold uppercase transition hover:opacity-90 ${l.color}`}
              >
                + {l.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-6 bg-white rounded-xl border border-gray-100 p-6">
          <h2 className="text-[14px] font-bold mb-3">View Website</h2>
          <p className="text-[13px] text-gray-500 mb-4">See how your changes look on the live website.</p>
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-5 py-2.5 border border-gray-300 rounded-lg text-[13px] font-semibold hover:border-[#e84fa5] hover:text-[#e84fa5] transition"
          >
            Open Website ↗
          </a>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Dashboard;
